import { Button } from '@mantine/core';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { verifyEmail } from 'supertokens-auth-react/recipe/emailverification';

import styles from './EmailVerificationForm.module.scss';
import { Props } from './EmailVerificationForm.types';

const EmailVerificationForm = ({ acknowledgeVerify }: Props) => {
  const { t } = useTranslation();
  const [verifying, setVerifying] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const verifyEmailAddress = useCallback(async () => {
    setVerifying(true);

    try {
      const response = await verifyEmail();

      if (response.status === 'OK') {
        acknowledgeVerify();
      } else if (response.status === 'EMAIL_VERIFICATION_INVALID_TOKEN_ERROR') {
        setError(t('emailVerification.invalidToken', 'Token de vérification invalide'));
      }
    } catch (error) {
      setError(
        t('emailVerification.validationError', 'Une erreur est survenue lors de la vérification')
      );
      console.error(error);
    } finally {
      setVerifying(false);
    }
  }, [acknowledgeVerify, t]);

  return (
    <div className={styles.container}>
      <p className={styles.title}>
        {t('emailVerification.verifyEmail', 'Vérifiez votre adresse email')}
      </p>
      <p className={styles.description}>
        {t(
          'emailVerification.verifyTitleMessage',
          'Cliquez sur le bouton ci-dessous pour vérifier votre adresse mail'
        )}
      </p>
      {error && <p className={styles.error}>{error}</p>}
      <Button variant="filled" onClick={verifyEmailAddress} loading={verifying}>
        {t('emailVerification.continue', 'Continuer')}
      </Button>
    </div>
  );
};

export default EmailVerificationForm;
